import { apiClient } from '@services/api-client'
import { SNA_PREFIX } from '@services/utils'

interface DownloadOfferProtocolParams {
  offerId: string
  protocolId: string
  protocolName: string
}

export async function downloadOfferProtocol({
  offerId,
  protocolId,
  protocolName
}: DownloadOfferProtocolParams) {
  const response = await apiClient.get(
    `${SNA_PREFIX}offers/${offerId}/protocols/${protocolId}/`,
    { responseType: 'blob' }
  )

  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', protocolName)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)
}

export async function viewOfferProtocol({
  offerId,
  protocolId
}: Omit<DownloadOfferProtocolParams, 'protocolName'>) {
  const response = await apiClient.get(
    `${SNA_PREFIX}offers/${offerId}/protocols/${protocolId}/`,
    { responseType: 'blob' }
  )

  const file = new Blob([response.data], { type: 'application/pdf' })
  const fileURL = URL.createObjectURL(file)
  window.open(fileURL, '_blank')
}
